<template>
  <div class="edit_front_page">
    <mdb-card v-if="this.loadReady === true">
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"><strong>{{ $t("front_page") }}</strong></mdb-card-title>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-row class="mt-5">
          <mdb-col md="12">
            <p class="h5">{{ $t("page_content") }}</p>
          </mdb-col>
          <mdb-col md="6">
            <UnionMemberSelection :defaultSelection="localFrontPage.id"
              v-on:unionmemberid="setUnionMemberId" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="12">
            <p class="h6">{{ $t("frontpage_titles") }}</p>
          </mdb-col>
          <mdb-col col="6">
            <mdb-input v-model="localFrontPage.title1" type="text" icon="quote-right"
              :label="$t('frontpage_title1')" />
          </mdb-col>
          <mdb-col col="6">
            <mdb-input v-model="localFrontPage.title2" type="text" icon="quote-right"
              :label="$t('frontpage_title2')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="6">
            <mdb-input v-model="localFrontPage.title3" type="text" icon="quote-right"
              :label="$t('frontpage_title3')" />
          </mdb-col>
          <mdb-col col="6">
            <mdb-input v-model="localFrontPage.title4" type="text" icon="quote-right"
              :label="$t('frontpage_title4')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="12">
            <p class="h6">{{ $t("frontpage_links") }}</p>
          </mdb-col>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext1" type="text" icon="quote-right"
              :label="$t('frontpage_linktext1')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link1" type="text" icon="quote-right"
              :label="$t('frontpage_link1')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext2" type="text" icon="quote-right"
              :label="$t('frontpage_linktext2')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link2" type="text" icon="quote-right"
              :label="$t('frontpage_link2')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext3" type="text" icon="quote-right"
              :label="$t('frontpage_linktext3')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link3" type="text" icon="quote-right"
              :label="$t('frontpage_link3')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext4" type="text" icon="quote-right"
              :label="$t('frontpage_linktext4')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link4" type="text" icon="quote-right"
              :label="$t('frontpage_link4')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext5" type="text" icon="quote-right"
              :label="$t('frontpage_linktext5')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link5" type="text" icon="quote-right"
              :label="$t('frontpage_link5')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext6" type="text" icon="quote-right"
              :label="$t('frontpage_linktext6')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link6" type="text" icon="quote-right"
              :label="$t('frontpage_link6')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext7" type="text" icon="quote-right"
              :label="$t('frontpage_linktext7')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link7" type="text" icon="quote-right"
              :label="$t('frontpage_link7')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="5">
            <mdb-input v-model="localFrontPage.linktext8" type="text" icon="quote-right"
              :label="$t('frontpage_linktext8')" />
          </mdb-col>
          <mdb-col col="7">
            <mdb-input v-model="localFrontPage.link8" type="text" icon="quote-right"
              :label="$t('frontpage_link8')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="12">
            <p class="h6">{{ $t("frontpage_logo_and_backgroundcolor") }}</p>
          </mdb-col>
          <mdb-col>
            <ImageInput :image-src="this.localFrontPage.logo" :imageWidth="300" :buttonName="$t('add_logo')"
              v-on:general-image="logoImg" />
              <mdb-input v-model="localFrontPage.backgroundcolor" type="text" icon="quote-right"
              :label="$t('frontpage_background_color')" />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col col="12">
            <p class="h6">{{ $t("frontpage_images") }}</p>
          </mdb-col>
          <mdb-col>
            <ImageInput :image-src="this.localFrontPage.img1" :imageWidth="300" :buttonName="$t('add_img1')" :deleteButton="true"
              v-on:general-image="pageImg1" />
              <mdb-input v-model="localFrontPage.imglink1" type="text" icon="quote-right"
              :label="$t('frontpage_imglink1')" />
            <hr />
          </mdb-col>
          <mdb-col>
            <ImageInput :image-src="this.localFrontPage.img2" :imageWidth="300" :buttonName="$t('add_img2')" :deleteButton="true"
              v-on:general-image="pageImg2" />
              <mdb-input v-model="localFrontPage.imglink2" type="text" icon="quote-right"
              :label="$t('frontpage_imglink2')" />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <ImageInput :image-src="this.localFrontPage.img3" :imageWidth="300" :buttonName="$t('add_img3')" :deleteButton="true"
              v-on:general-image="pageImg3" />
              <mdb-input v-model="localFrontPage.imglink3" type="text" icon="quote-right"
              :label="$t('frontpage_imglink3')" />
            <hr />
          </mdb-col>
          <mdb-col>
            <ImageInput :image-src="this.localFrontPage.img4" :imageWidth="300" :buttonName="$t('add_img4')" :deleteButton="true"
              v-on:general-image="pageImg4" />
              <mdb-input v-model="localFrontPage.imglink4" type="text" icon="quote-right"
              :label="$t('frontpage_imglink4')" />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <ImageInput :image-src="this.localFrontPage.img5" :imageWidth="300" :buttonName="$t('add_img5')" :deleteButton="true"
              v-on:general-image="pageImg5" />
              <mdb-input v-model="localFrontPage.imglink5" type="text" icon="quote-right"
              :label="$t('frontpage_imglink5')" />
            <hr />
          </mdb-col>
          <mdb-col>
            <ImageInput :image-src="this.localFrontPage.img6" :imageWidth="300" :buttonName="$t('add_img6')" :deleteButton="true"
              v-on:general-image="pageImg6"/>
              <mdb-input v-model="localFrontPage.imglink6" type="text" icon="quote-right"
              :label="$t('frontpage_imglink6')" />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12" class="mt-4">
            <mdb-btn @click="saveFrontPage" color="indigo" class="white-text" icon="paper-plane" style="width: 200px">{{
              $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";
import UnionMemberSelection from "@/components/UnionMemberSelection.vue";
import ImageInput from "@/components/ImageInput.vue";
export default {
  name: "AddFrontPage",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    ImageInput,
    UnionMemberSelection,
  },
  methods: {
    setUnionMemberId(val) {
      this.localFrontPage.id = val;
    },
    logoImg(val) {
      this.localFrontPage.logo = val;
    },
    pageImg1(val) {
      this.localFrontPage.img1 = val;
    },
    pageImg2(val) {
      this.localFrontPage.img2 = val;
    },
    pageImg3(val) {
      this.localFrontPage.img3 = val;
    },
    pageImg4(val) {
      this.localFrontPage.img4 = val;
    },
    pageImg5(val) {
      this.localFrontPage.img5 = val;
    },
    pageImg6(val) {
      this.localFrontPage.img6 = val;
    },
    loadFrontPage() {
    if (this.$route.params.id == undefined) {
        this.localFrontPage.id = 0;
        this.loadReady = true;
        return;
      }
      this.getFrontPage(this.$route.params.id);
    },
    fillLocalFrontPage(val) {
      // todo check how image and imagelink are used
      this.localFrontPage.title1 = val.title1;
      this.localFrontPage.title2 = val.title2;
      this.localFrontPage.title3 = val.title3;
      this.localFrontPage.title4 = val.title4;
      this.localFrontPage.linktext1 = val.linktext1;
      this.localFrontPage.link1 = val.link1;
      this.localFrontPage.linktext2 = val.linktext2;
      this.localFrontPage.link2 = val.link2;
      this.localFrontPage.linktext3 = val.linktext3;
      this.localFrontPage.link3 = val.link3;
      this.localFrontPage.linktext4 = val.linktext4;
      this.localFrontPage.link4 = val.link4;
      this.localFrontPage.linktext5 = val.linktext5;
      this.localFrontPage.link5 = val.link5;
      this.localFrontPage.linktext6 = val.linktext6;
      this.localFrontPage.link6 = val.link6;
      this.localFrontPage.linktext7 = val.linktext7;
      this.localFrontPage.link7 = val.link7;
      this.localFrontPage.linktext8 = val.linktext8;
      this.localFrontPage.link8 = val.link8;
      this.localFrontPage.img1 = val.img1;
      this.localFrontPage.imglink1 = val.imglink1;
      this.localFrontPage.img2 = val.img2;
      this.localFrontPage.imglink2 = val.imglink2;
      this.localFrontPage.img3 = val.img3;
      this.localFrontPage.imglink3 = val.imglink3;
      this.localFrontPage.img4 = val.img4;
      this.localFrontPage.imglink4 = val.imglink4;
      this.localFrontPage.img5 = val.img5;
      this.localFrontPage.imglink5 = val.imglink5;
      this.localFrontPage.img6 = val.img6;
      this.localFrontPage.imglink6 = val.imglink6;
      this.localFrontPage.logo = val.logo;
      this.localFrontPage.backgroundcolor = val.backgroundcolor;
      this.localFrontPage.id = val.id;
      console.log(val);
    },
    getFrontPage(frontpageid) {
      this.$notify.info({
        message: this.$t("loading_front_page"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(
          this.getfrontpagepath +
            "/" +
            frontpageid
        )
        .then((response) => {
          if (response.status == 200) {

            this.fillLocalFrontPage(response.data.unionmembers[0]);
            this.loadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    saveFrontPage() {
      try {
        this.postData = {
          sessionid: this.$store.getters.getToken,
          id: this.localFrontPage.id,
          title1: this.localFrontPage.title1,
          title2: this.localFrontPage.title2,
          title3: this.localFrontPage.title3,
          title4: this.localFrontPage.title4,
          linktext1: this.localFrontPage.linktext1,
          link1: this.localFrontPage.link1,
          linktext2: this.localFrontPage.linktext2,
          link2: this.localFrontPage.link2,
          linktext3: this.localFrontPage.linktext3,
          link3: this.localFrontPage.link3,
          linktext4: this.localFrontPage.linktext4,
          link4: this.localFrontPage.link4,
          linktext5: this.localFrontPage.linktext5,
          link5: this.localFrontPage.link5,
          linktext6: this.localFrontPage.linktext6,
          link6: this.localFrontPage.link6,
          linktext7: this.localFrontPage.linktext7,
          link7: this.localFrontPage.link7,
          linktext8: this.localFrontPage.linktext8,
          link8: this.localFrontPage.link8,
          img1: this.localFrontPage.img1 != null ? this.localFrontPage.img1 : "",
          imglink1: this.localFrontPage.imglink1,
          img2: this.localFrontPage.img2 != null ? this.localFrontPage.img2 : "",
          imglink2: this.localFrontPage.imglink2,
          img3: this.localFrontPage.img3 != null ? this.localFrontPage.img3 : "",
          imglink3: this.localFrontPage.imglink3,
          img4: this.localFrontPage.img4 != null ? this.localFrontPage.img4 : "",
          imglink4: this.localFrontPage.imglink4,
          img5: this.localFrontPage.img5 != null ? this.localFrontPage.img5 : "",
          imglink5: this.localFrontPage.imglink5,
          img6: this.localFrontPage.img6 != null ? this.localFrontPage.img6 : "",
          imglink6: this.localFrontPage.imglink6,
          logo: this.localFrontPage.logo != null ? this.localFrontPage.logo : "",
          backgroundcolor: this.localFrontPage.backgroundcolor

        };
        this.$http
          .post(
            this.updatefrontpagepath,
            JSON.stringify(this.postData)
          )
          .then((response) => {
            if (response.status == 200) {
              this.$notify.success({
                message: this.$t("adding_front_page_success"),
                position: "top right",
                timeOut: this.$store.state.notifytimeoutshort,
              });
            }
            this.$emit("modal-ok");
            this.$router.push("/frontpages");
          })
          .catch((error) => {
            this.$notify.error({
              message: this.$t("adding_front_page_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
            this.$emit("modal-ok");
            console.log(error);
          })
          .finally(() => (this.loading = false));
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.loadFrontPage();
  },
  data() {
    return {
      getfrontpagepath: "/1.0/front/unionmember",
      updatefrontpagepath: "1.0/front/unionmember/frontpage",
      loadReady: false,
      componentKey: 0,
      localFrontPage: {
        id: 0,
        title1: "",
        title2: "",
        title3: "",
        title4: "",
        linktext1: "",
        link1: "",
        linktext2: "",
        link2: "",
        linktext3: "",
        link3: "",
        linktext4: "",
        link4: "",
        linktext5: "",
        link5: "",
        linktext6: "",
        link6: "",
        linktext7: "",
        link7: "",
        linktext8: "",
        link8: "",
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
      },
    };
  },
};
</script>

<style></style>
